import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import useUserService from '../../../../userManagement/utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';
import { IPermissionSet } from '../../../../../../models/settingsV2.model';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert, app } = useContext(AppContext);
	const { requestUpdatePermissionsSet } = useService();
	const { getPermissionsOptions } = useUserService();

	const location = useLocation();
	const data: IPermissionSet = _get(location, ['state', 'rowData']);
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.SELECT_PERMISSIONS].setRenderProps({ getOptions: getPermissionsOptions });
	const updatePermissionsSet = async (updatedData: IPermissionSet) => {
		setShowLoader(true);
		try {
			const response = await requestUpdatePermissionsSet(app.appName, updatedData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to edit permissions set');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while editing this Permission Set', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permission Set edited successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (submittedData: IPermissionSet) => {
		updatePermissionsSet(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
